/* hs-eslint ignored failing-rules */

/* eslint-disable prefer-promise-reject-errors */
import { isGoogleSignup } from '../app/verificationTypeSelectors';
import { Data } from '../signup-data/DATA';
import { getHublet } from '../store/app/selectors';
import { getAuthenticatedUser } from '../store/auth/selectors';
import { getFlatSignupDataValueMap, getSignupDataValue } from '../store/signup-data/selectors';
import LoginClient from './LoginClient';
export const loginNewUser = (state, dispatch) => {
  const authedUser = getAuthenticatedUser(state);

  if (authedUser && getSignupDataValue(state, Data.Email) === authedUser.email) {
    return Promise.resolve();
  }

  const signupData = getFlatSignupDataValueMap(state);
  const email = signupData[Data.Email];
  const password = signupData[Data.Password];
  const idToken = signupData[Data.GoogleIdToken];
  const hublet = getHublet(state);
  const googleSignup = isGoogleSignup(state);
  const hasDataForPasswordLogin = email && password;
  const hasDataForGoogleLogin = googleSignup && idToken;

  if (!hasDataForPasswordLogin && !hasDataForGoogleLogin) {
    return Promise.reject();
  }

  if (googleSignup) {
    return LoginClient.google(idToken);
  }

  return LoginClient.password(email, password, hublet, dispatch);
};